import { argSel, getCtData, goTo, setData } from '../../project';
import {
  runTransaction,
  doc,
  updateDoc,
  DocumentReference,
} from 'firebase/firestore';
import { firestoreOutFlax } from '../../functions/firebase/firebase';
import { updateDocTool } from '../../functions/firebase/updateDoc';
import { setDocTool } from '../../functions/firebase/setDoc';
import { TMergedLocalBikes } from '../mergeLocationBikes';
import { setErrorTrue } from './helpers/setCtDataError';
import { checkoutPath } from './helpers/paths';
import { unlockBike } from './helpers/unlockBike';

type Tprops = {
  args: any;
  pass: {
    ipt1: any[];
    ipt2: string;
    ipt3: any[];
  };
};

export const payAndSetFireBase = async (props?: Tprops) => {
  console.log('fakeOrder', 'Fluxo sem pagamento iniciado');
  setData({ path: 'all.toggles.loaderPurchase', value: 'show' });

  const fakePaymentData = {
    id: `offline-${Date.now()}`,
    status: 'paid',
    payment_method: 'none',
    gateway: 'disabled',
  };

  setData({
    path: 'sc.B4.currData.checkout.paymentData',
    value: fakePaymentData,
  });

  const fireInit = getCtData('all.fireInit');
  const passProps1 = {
    fbInit: [fireInit],
    arrRefStrings: ['rents'],
    arrPathData: ['sc.B4.currData.checkout'],
    arrFuncs: [
      async (...args) => {
        const dataToUpdate = {
          ['activeRentData.rentId']: argSel(args, '#0.docId'),
        };
        setData({ path: 'all.tempData', value: dataToUpdate });

        const selectedUser = getCtData('all.userData.docId');
        const fireInit = getCtData('all.fireInit');
        const passProps2 = {
          fbInit: [fireInit],
          arrRefStrings: ['users', selectedUser],
          arrPathData: ['all.tempData'],
          arrFuncs: [
            () => {
              setData({ path: 'all.toggles.loaderPurchase', value: null });
            },
            async () => {
              const locationType = getCtData(
                'sc.B3A.currData.currLocation.data.locationType',
              );
              const arrayAutoBikes = getCtData('sc.B3C.currData.mainList');
              const stationApiID = getCtData(
                'sc.B3A.currData.currLocation.data.apiLocationID',
              );
              console.log('fakeOrder: stationApiID', { stationApiID });

              const arrayBayIds = arrayAutoBikes
                .filter(
                  item =>
                    item.rackStatus === 'lock' && item.status === 'available',
                )
                .map(item => ({
                  currId: item.rackID,
                  actions: 'unlock' as const,
                  stationApiID,
                }));

              await unlockBike(arrayBayIds);

              if (locationType === 'Autônomo') {
                setData({
                  path: 'sc.B3A.currData.currLocation.data',
                  value: {},
                });
                goTo('b5timerAuto');
              }

              if (locationType === 'Supervisionado') {
                goTo('b5timer');
              }
            },
          ],
        };

        await updateDocTool({ args, pass: passProps2 });
        setData({ path: 'all.tempData', value: null });
      },
    ],
  };

  await setDocTool({ args: {}, pass: passProps1 });

  console.log('fakeOrder - SUCCESS', fakePaymentData);
  return fakePaymentData;
};

export const fakeOrder = async (props?: Tprops) => {
  let bikesList: TMergedLocalBikes[] = getCtData(checkoutPath + '.bikesList');
  const currLocationId = getCtData('sc.B4.currData.checkout.locationId');
  console.log({ bikesList });

  const docsToUpdate: DocumentReference[] = [];

  try {
    await runTransaction(firestoreOutFlax, async transaction => {
      for (const currBike of bikesList) {
        console.log({ currBike });
        for (const currID of currBike.allLocalIds) {
          const ref = doc(
            firestoreOutFlax,
            'locations',
            currLocationId,
            'localBikes',
            currID,
          );

          const snap = await transaction.get(ref);
          if (!snap.exists()) throw new Error(`Bike ${currID} não existe`);

          const data = snap.data();
          if (data.status !== 'available') {
            throw new Error(
              `Bike ${
                currBike.modelName ?? currID
              } já foi alugada por outra pessoa.`,
            );
          }

          docsToUpdate.push(ref);
        }
      }
    });

    const res = await payAndSetFireBase(props);
    if (!res) throw new Error('Fluxo de locação não confirmado');

    const arrPromises = docsToUpdate.map(ref =>
      updateDoc(ref, { status: 'unavailable' }),
    );
    await Promise.all(arrPromises);

    console.log('Status das bikes atualizado para "unavailable" com sucesso');
  } catch (err: any) {
    console.error('Erro no fluxo do Cartão de Crédito:', err.message);
    setErrorTrue(err.message);
    setData({ path: 'all.toggles.loaderPurchase', value: null });
    return;
  }
};
